import type { VerbTypes } from 'modules/core/lib/verbTypes'

import Policy from './Policy'

class LeavePolicy extends Policy<VerbTypes> {
  checkVerb(verb: VerbTypes): boolean {
    switch (verb) {
      case 'updateCustomField':
        return this.permissions.update

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
      // TODO: DRY
    }
  }
}

export default LeavePolicy
